<template>
  <div class="admin-chat" ref="chat">
    <div class="admin-chat__content">
      <span class="admin-chat__today" v-if="messages.length > 0"
        >{{ $t("chat-button.today") }}
      </span>
      <div
        v-for="(message, i) in messages"
        :key="message.id + i"
        class="admin-chat__messages"
      >
        <chat-message :message="message" :received="message.received" />
      </div>
    </div>
  </div>
</template>

<script>
import ChatMessage from './ChatMessage.vue';

export default {
  components: {
    ChatMessage,
  },
  watch: {
    messages(newValue) {
      if (newValue) {
        this.scrollToBottom();
      }
    },
  },
  props: {
    messages: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  methods: {
    scrollToBottom() {
      const container = this.$refs.chat;
      container.scrollTop = container.scrollHeight;
    },
  },
};
</script>

<style scoped lang="scss">
@import "~styles/components/chatButton/_chat-button.scss";
</style>
